(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baby-bundle-product"]) return;
  try {
    
  if (!customElements.get('bundle-gallery')) {
    class BundleGallery extends HTMLElement {
      connectedCallback() {
        const slides = Array.from(this.querySelectorAll('[data-bb-slide]'));
        const thumbs = Array.from(this.querySelectorAll('[data-bb-thumb]'));

        thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => {
            slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
            thumbs.forEach((other, i) => other.setAttribute('aria-current', i === index ? 'true' : 'false'));
          });
        });
      }
    }

    customElements.define('bundle-gallery', BundleGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baby-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nt-baby')) {
    class NtBaby extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.disposers = [];
        this.setupReveal();
        this.setupExplorer();
        this.setupVideos();
        this.setupCompare();
        this.setupAccordion();
      }

      disconnectedCallback() {
        (this.disposers || []).forEach((dispose) => dispose());
        this.disposers = [];
      }

      observe(elements, options, callback) {
        if (!('IntersectionObserver' in window)) return null;
        const observer = new IntersectionObserver(callback, options);
        elements.forEach((el) => observer.observe(el));
        this.disposers.push(() => observer.disconnect());
        return observer;
      }

      /* ── scroll reveal ── */
      setupReveal() {
        const items = Array.from(this.querySelectorAll('[data-nt-reveal]'));
        const inEditor = document.documentElement.classList.contains('shopify-design-mode');
        if (inEditor || this.reduce || !('IntersectionObserver' in window)) return;

        this.classList.add('nt-js');
        const observer = this.observe(items, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }, (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('nt-in');
            observer.unobserve(entry.target);
          });
        });

        // safety net: never leave content hidden
        const timer = window.setTimeout(() => items.forEach((el) => el.classList.add('nt-in')), 4500);
        this.disposers.push(() => window.clearTimeout(timer));
      }

      /* ── product explorer ── */
      setupExplorer() {
        const root = this.querySelector('[data-nt-explorer]');
        if (!root) return;

        const tabs = Array.from(root.querySelectorAll('[data-nt-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-nt-panel]'));
        const pins = Array.from(root.querySelectorAll('[data-nt-pin]'));
        const stage = root.querySelector('.nt-stage');
        if (!tabs.length) return;

        const interval = 6500;
        let index = 0;
        let stopped = this.dataset.autoplay !== 'true' || this.reduce;
        let paused = false;
        let visible = false;
        let timer = 0;

        root.style.setProperty('--nt-dur', interval + 'ms');

        const select = (next, { focus = false } = {}) => {
          index = (next + tabs.length) % tabs.length;
          tabs.forEach((tab, i) => {
            const on = i === index;
            tab.classList.toggle('is-active', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
          });
          panels.forEach((panel, i) => {
            panel.hidden = i !== index;
          });
          pins.forEach((pin, i) => pin.classList.toggle('is-active', i === index));

          const pin = pins[index];
          if (pin && stage) {
            stage.style.setProperty('--gx', pin.style.getPropertyValue('--x'));
            stage.style.setProperty('--gy', pin.style.getPropertyValue('--y'));
            const accent = getComputedStyle(tabs[index]).getPropertyValue('--a').trim();
            if (accent) stage.style.setProperty('--glow', accent);
          }
          if (focus) tabs[index].focus();
        };

        const schedule = () => {
          window.clearTimeout(timer);
          root.classList.toggle('is-auto', !stopped && !paused && visible);
          if (stopped || paused || !visible) return;
          timer = window.setTimeout(() => {
            select(index + 1);
            schedule();
          }, interval);
        };

        const userSelect = (next, opts) => {
          stopped = true;
          root.classList.add('is-touched');
          select(next, opts);
          schedule();
        };

        tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => userSelect(i));
          tab.addEventListener('keydown', (event) => {
            const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
            if (event.key in keys) {
              event.preventDefault();
              userSelect(index + keys[event.key], { focus: true });
            } else if (event.key === 'Home') {
              event.preventDefault();
              userSelect(0, { focus: true });
            } else if (event.key === 'End') {
              event.preventDefault();
              userSelect(tabs.length - 1, { focus: true });
            }
          });
        });

        pins.forEach((pin, i) => {
          pin.addEventListener('click', () => userSelect(i));
          pin.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') userSelect(i);
          });
        });

        root.addEventListener('pointerenter', () => {
          paused = true;
          schedule();
        });
        root.addEventListener('pointerleave', () => {
          paused = false;
          schedule();
        });
        root.addEventListener('focusin', () => {
          paused = true;
          schedule();
        });
        root.addEventListener('focusout', () => {
          paused = false;
          schedule();
        });
        root.addEventListener('submit', () => {
          stopped = true;
          schedule();
        });

        this.observe([root], { threshold: 0.35 }, ([entry]) => {
          visible = entry.isIntersecting;
          schedule();
        });
        if (!('IntersectionObserver' in window)) visible = false;

        this.disposers.push(() => window.clearTimeout(timer));
        select(0);
      }

      /* ── videos: play when in view, pause when not ── */
      setupVideos() {
        const cards = Array.from(this.querySelectorAll('[data-nt-video]'));
        if (!cards.length) return;

        const states = cards.map((card) => {
          const video = card.querySelector('video');
          const playBtn = card.querySelector('[data-nt-play]');
          const muteBtn = card.querySelector('[data-nt-mute]');
          const state = { card, video, userPaused: false, inView: false };

          const sync = () => {
            const paused = video.paused;
            card.classList.toggle('is-paused', paused);
            card.classList.toggle('is-unmuted', !video.muted);
            playBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
            muteBtn.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
            muteBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          };

          video.addEventListener('play', sync);
          video.addEventListener('pause', sync);
          video.addEventListener('volumechange', sync);

          playBtn.addEventListener('click', () => {
            if (video.paused) {
              state.userPaused = false;
              video.play().catch(() => {});
            } else {
              state.userPaused = true;
              video.pause();
            }
          });

          muteBtn.addEventListener('click', () => {
            video.muted = !video.muted;
            if (!video.muted) {
              states.forEach((other) => {
                if (other !== state) other.video.muted = true;
              });
              if (video.paused) {
                state.userPaused = false;
                video.play().catch(() => {});
              }
            }
          });

          card.classList.add('is-paused');
          return state;
        });

        const byVideo = new Map(states.map((state) => [state.video, state]));

        this.observe(
          states.map((state) => state.video),
          { threshold: 0.55 },
          (entries) => {
            entries.forEach((entry) => {
              const state = byVideo.get(entry.target);
              state.inView = entry.isIntersecting;
              if (entry.isIntersecting && !state.userPaused && !this.reduce) {
                state.video.play().catch(() => {});
              } else if (!entry.isIntersecting) {
                state.video.pause();
              }
            });
          }
        );

        const onHide = () => {
          if (document.hidden) states.forEach((state) => state.video.pause());
        };
        document.addEventListener('visibilitychange', onHide);
        this.disposers.push(() => document.removeEventListener('visibilitychange', onHide));
      }

      /* ── before / after slider (a full-size native range keeps it touch- and keyboard-friendly) ── */
      setupCompare() {
        const root = this.querySelector('[data-nt-compare]');
        if (!root) return;
        const range = root.querySelector('.nt-compare__range');
        let touched = false;

        const set = (value) => root.style.setProperty('--pos', value + '%');
        const cancelPeek = () => {
          touched = true;
          root.classList.remove('is-anim');
        };

        range.addEventListener('input', () => {
          cancelPeek();
          set(range.value);
        });
        range.addEventListener('pointerdown', cancelPeek);
        range.addEventListener('keydown', cancelPeek);

        // a small "peek" the first time it scrolls into view so people can tell it moves
        if (this.reduce) return;
        this.observe([root], { threshold: 0.6 }, ([entry], observer) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          root.classList.add('is-anim');
          [72, 30, 50].forEach((value, i, all) => {
            const timer = window.setTimeout(() => {
              if (touched) return;
              range.value = String(value);
              set(value);
              if (i === all.length - 1) window.setTimeout(() => root.classList.remove('is-anim'), 800);
            }, 500 + i * 850);
            this.disposers.push(() => window.clearTimeout(timer));
          });
        });
      }

      /* ── FAQ accordion ── */
      setupAccordion() {
        const items = Array.from(this.querySelectorAll('.nt-acc__item'));
        items.forEach((item) => {
          const button = item.querySelector('.nt-acc__q');
          button.addEventListener('click', () => {
            const open = !item.classList.contains('is-open');
            items.forEach((other) => {
              const isThis = other === item;
              const state = isThis ? open : false;
              other.classList.toggle('is-open', state);
              other.querySelector('.nt-acc__q').setAttribute('aria-expanded', state ? 'true' : 'false');
            });
          });
        });
      }
    }

    customElements.define('nt-baby', NtBaby);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
